import { Route, RouteComponentProps } from 'react-router-dom';
import Forbidden from '../pages/Forbidden/Forbidden';
import NotFound from '../pages/NotFound/NotFound';
import { RouteProps, StaticContext } from 'react-router';
import { useMemo } from 'react';

export type LogicalRouteImportProps = {
    path: string;
} & RouteProps;

export type BlockPageRoutingProps =
    | {
          blockPageComponent:
              | React.ComponentType<any>
              | React.ComponentType<RouteComponentProps<any, StaticContext, unknown>>;
          displayBlockPage: boolean;
      }
    | {
          blockPageComponent?: never;
          displayBlockPage?: never;
      };

export type LogicalRouteProps = {
    path: string;
    component: React.ComponentType<any> | React.ComponentType<RouteComponentProps<any, StaticContext, unknown>>;
    disabled?: boolean;
    isLoading?: boolean;
    isForbidden?: boolean;
    isNotFound?: boolean;
} & BlockPageRoutingProps &
    RouteProps;

export function LogicalRoute({
    path,
    component,
    disabled = false,
    isLoading = false,
    isForbidden = false,
    isNotFound = false,
    blockPageComponent,
    displayBlockPage,
    ...props
}: LogicalRouteProps): JSX.Element | null {
    const activeComponent = useMemo(
        () => (displayBlockPage ? blockPageComponent : isForbidden ? Forbidden : isNotFound ? NotFound : component),
        [blockPageComponent, component, displayBlockPage, isForbidden, isNotFound]
    );

    if (isLoading) {
        return (
            <div className="silverfort-loader">
                <div className="logo"></div>
            </div>
        );
    }

    if (disabled) {
        return <Route path={path} component={NotFound} />;
    }

    return <Route path={path} component={activeComponent} {...props} />;
}
